export default "__VITE_ASSET__rVwXmsra__"